import { render, staticRenderFns } from "./RentPayerHome.vue?vue&type=template&id=465fa808&scoped=true&"
import script from "./RentPayerHome.vue?vue&type=script&lang=js&"
export * from "./RentPayerHome.vue?vue&type=script&lang=js&"
import style0 from "./RentPayerHome.vue?vue&type=style&index=0&id=465fa808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465fa808",
  null
  
)

export default component.exports